import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const StatsBox = ({ data, config }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  return (
    <div className="stats-box">
      <div className="row">
        <div className="col-1 text-start mt-2"></div>
        <div className="col-11 text-start mt-2"><strong>{config?.header}</strong></div>
      </div>
      {config?.stats?.map((item) => {
        let stat;
        if (item.eventUnitEntries === undefined) {
          stat = data?.cumStatsItems?.find(i => i.code === item.code)
          if (stat !== undefined && item.subCode !== undefined) {
            stat = stat?.extendedStats.find(i => i.code === item.subCode)
          }
        } else {
          stat = data?.eventUnitEntries?.find(i => i.eue_code === item.code)
        }

        const statValue = stat !== undefined && stat[item.attr] !== undefined ? stat[item.attr] : ''

        return (
          <div className="row" key={item.order}>
            <div className="col-1 text-start"></div>
            <div className="col-3 text-start"><Label data={item.label} sport={mirs_discipline} />:</div>
            <div className="col-6 text-end">{statValue}</div>
            <div className="col-2 text-end"></div>
          </div>
        )
      })}
      <div className="row">
        <div className="col-1 text-start mt-2"></div>
        <div className="col-11 text-start mt-2"><Label data={'BottonTextMatch'} sport={mirs_discipline} /></div>
      </div>

    </div>
  )

}

export default StatsBox;



